















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    BaseButton
  }
})
export default class ActionShowButtonI extends Vue {
  @Prop() label?: string
  @Prop({ required: true }) url!: string
  @Prop({ default: 'information-circle-outline' }) icon?: string

  get iconName() {
    return `ion ${this.icon}`
  }
}
